import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  CreateFlexibleBenefitInput,
  CreateFlexibleBenefitResponse,
  CreateFlexibleBenefitVariables,
} from '../types';

const createFlexibleBenefitMutation = gql`
  mutation CreateFlexibleBenefitsComponent($input: CreateComponentInput!) {
    payrollCreateFlexibleBenefitsComponent(input: $input) {
      source
      data {
        id
        name
        description
        category
        region
        component_type
        is_active
        tenant_id
        merchant_id
        created_at
        updated_at
        system_component_id
      }
      code
      success
      message
    }
  }
`;

export const createFlexibleBenefit = (input: CreateFlexibleBenefitInput) => {
  return graphQLApi<CreateFlexibleBenefitResponse, CreateFlexibleBenefitVariables>({
    query: createFlexibleBenefitMutation,
    queryVariables: { input },
  });
};
